<template>
    <v-layout column align-start justify-start d-flex fluid fill-height mt-3>
        <v-container fluid py-0 my-0>
            <v-row justify = 'center' class = 'mb-2 mt-0 py-0'>
                <v-col :cols = '$vuetify.breakpoint.smAndUp? 8:12'>
                    <v-card flat :style = '`overflow: hidden; box-shadow: 0px 0px 30px 2px ${$store.getters.appTheme.shadow}; border-radius: 4px;`'>
                        <v-card-text>
                            <v-layout row>
                                <v-avatar :size = '$vuetify.breakpoint.smAndUp? "96px":"64px"' class = 'ml-2 mr-4'>
                                    <img :src = '$store.getters.userAvatar'>
                                </v-avatar>
                                <v-layout column mr-2 :class = '!this.$vuetify.theme.dark? `black--text`:``'>
                                    <v-layout align-center justify-start>
                                        <v-tooltip bottom>
                                            <template v-slot:activator = '{ on }'>
                                                <v-icon small :color = '$store.getters.uiAccent' v-on = 'on'>
                                                    {{$store.getters.currentUser.superuser? 'mdi-shield-check-outline': 'mdi-shield-outline'}}
                                                </v-icon>
                                            </template>
                                            <span>Уровень доступа к сервису: {{$store.getters.currentUser.superuser? 'Администратор': 'Пользователь'}}</span>
                                        </v-tooltip>
                                        <span :class = '`font-weight-light ml-5 ${$vuetify.breakpoint.smAndUp? "display-1":"title"}`'>{{displayName}}</span>
                                    </v-layout>
                                    <v-layout align-center justify-start class = 'body-1'>
                                        <v-icon small color = 'blue lighten-1'>mdi-at</v-icon>
                                        <span class = 'ml-5 font-weight-light'>{{$store.getters.currentUser.login}}</span>
                                    </v-layout>
                                    <v-layout align-center justify-start>
                                        <v-icon small color = 'blue lighten-1'>mdi-toolbox-outline</v-icon>
                                        <v-chip 
                                            small outlined label 
                                            color = 'blue lighten-1'
                                            class = 'ml-5'
                                        >{{$store.getters.currentUser.domain}}</v-chip>
                                    </v-layout>
                                </v-layout>
                            </v-layout>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn 
                                depressed icon  
                                @click = 'toggleUiBlack'
                                class = 'ml-auto'
                            ><v-icon>mdi-invert-colors</v-icon></v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
            <v-row justify = 'center' class = 'my-2 mt-0 py-0'>
                <v-col :cols = '$vuetify.breakpoint.smAndUp? 8:12'>
                    <v-card flat :style = '`overflow: hidden; box-shadow: 0px 0px 30px 2px ${$store.getters.appTheme.shadow}; border-radius: 4px;`'>
                        <v-card-title class = 'font-weight-light display-1'>Явные доступы к отчетам</v-card-title>
                        <v-card-text>
                            <v-layout column :class = '!this.$vuetify.theme.dark? `grey--text text--darken-3`: ``'>
                                <span v-if = 'distinctReportsCounter'>В общей сложности вам предоставлены явные доступы к <b>{{distinctReportsCounter}}</b> отчетам. Просмотреть полный список отчетов можно в основном меню сайта.</span>
                                <span v-else>Пока что вам не предоставлены явные доступы к отчетам.</span>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row justify = 'center' class = 'mt-2 mt-0 py-0' v-if = 'grants.length'>
                <v-col :cols = '$vuetify.breakpoint.smAndUp? 8:12'>
                    <v-card flat :style = '`overflow: hidden; box-shadow: 0px 0px 30px 2px ${$store.getters.appTheme.shadow}; border-radius: 4px;`'>
                        <v-card-title class = 'font-weight-light display-1'>Неявные доступы к отчетам</v-card-title>
                        <v-card-text>
                            <v-layout column :class = '!this.$vuetify.theme.dark? `grey--text text--darken-3`: ``'>
                                <span>В общей сложности вам предоставлены неявные доступы к <b>{{this.$store.getters.userReports.length - distinctReportsCounter}}</b> отчетам. Правила предоставления неявных доступов к отчетам для вашего аккаунта описаны ниже.</span>
                                <v-data-table
                                    disable-sort
                                    :headers = "header" 
                                    :items = "grants" 
                                    no-data-text='Доступы не назначены' 
                                    :loading = 'indicator' 
                                    :server-items-length = 'grants.length' 
                                    hide-default-footer 
                                    style='width: 100%;'
                                    class = 'caption'
                                >
                                    <template v-slot:body = '{ items }'>
                                        <tbody>
                                            <tr v-for = "(item, i) in items" :key = "i" class = 'caption'>
                                                <td class = 'caption'>{{ item.mode_name }}</td>
                                                <td class = 'caption'>{{ displayFields[item.lookup_field] }}</td>
                                                <td class = 'caption'>{{ getLookupValue(item.lookup_field, item.lookup_value) }}</td>
                                                <td class = 'caption'>{{ modes[item.mode_edit] }}</td>
                                                <td class = 'caption'>{{ modes[item.mode_persons] }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-data-table>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-layout>
</template>

<script>
    export default {
        name: 'profile',
        data: () => ({
            indicator: false,
            grants: [],
            modes: {
                'X': 'Полный доступ',
                'U': 'Создание и редактирование',
                'W': 'Редактирование',
                'R': 'Просмотр'
            },
            displayFields: {
                'segment_id': 'Сегмент проекта',
                'vertical_id': 'Вертикаль проекта',
                'name': 'Название проекта',
                'segment': 'Сегмент проекта',
                'vertical': 'Вертикаль проекта',
            },
            header: [
                { text: 'Роль', value: 'mode_name' },
                { text: 'Поиск', value: 'lookup_field' },
                { text: 'Значение', value: 'lookup_value' },
                { text: 'Содержимое', value: 'mode_edit' },
                { text: 'Пользователи', value: 'mode_persons' },
            ]
        }),
        computed: {
            user() {
                return this.$store.getters.currentUser
            },
            displayName() {
                return this.user.name + ' ' + this.user.lastname
            },
            projectSegments() {
                return this.$store.state.segments
            },
            projectVerticals() {
                return this.$store.state.verticals
            },
            distinctReportsCounter() {
                return this.$store.getters.userReports.filter( (r) => r.grant_name == 'default' || r.grant_name == 'super').length
            },
            isUiBlack() {
                return this.$vuetify.theme.dark
            }
        },
        methods: {
            toggleUiBlack() {
                this.$store.dispatch('toggleUserTheme')
                this.$dataLayer.$emit('enrich', {
                    event: 'interaction',
                    data: {
                        type: 'change_view',
                        target: 'theme'
                    },
                    once: false
                })
            },
            getIndirectGrants() {
                this.indicator = true;
                let requestData = {
                    'indirect': 1,
                    'user': this.user.uid,
                    'superuser': this.user.superuser,
                    'login': this.$store.getters.userLogin
                }
                this.$http.get(this.$store.getters.endpoint + '/db/person/grants', {
                    emulateJSON: true,
                    params: requestData,
                    headers: this.$store.state.restrictedHeaders
                }).then((r) => {
                    let response = r.body
                    this.indicator = false
                    if (response.result) {
                        this.grants = response.data
                    }
                })
            },
            getLookupValue(type, mean) {
                if (type == 'segment_id') {
                    let segment = this.projectSegments.filter( (v) => v.segment_id == mean)
                    return segment[0].segment_name
                }
                else if (type == 'vertical_id') {
                    let vertical = this.projectVerticals.filter( (v) => v.vertical_id == mean)
                    return vertical[0].vertical_name
                } else {
                    return mean
                }
            }
        },
        mounted() {
            this.$store.dispatch('fillSegments')
            this.$store.dispatch('fillVerticals')
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.getIndirectGrants();
                vm.$store.commit('setBreadcrumbs', [
                    { text: 'Главная', disabled: false, href: '#/' },
                    { text: 'Профиль', disabled: true, href: '#/me' }
                ]);
            });
        }
    }
</script>